export interface Buyer {
  name: string
  color: string // Tailwind bg class
  textColor: string // Tailwind text class
  hex: string // For legend swatch
  brands: string[]
}

export const buyers: Buyer[] = [
  {
    name: 'Boitumelo Mpisane',
    color: 'bg-blue-500',
    textColor: 'text-white',
    hex: '#3B82F6',
    brands: [
      'Chanel',
      'Dolce + Gabbana',
      'Gucci',
      'Elie Saab',
      'Narciso Rodriguez',
      'Hugo Boss',
      'Bvlgari',
      'Issey Miyake',
      'Burberry',
      'Hermès',
      'Nesti Soaps',
      'Coach',
      'Marc Jacobs',
      'Jimmy Choo',
      'Mont Blanc',
      'Acqua di Parma',
      'Donna Karan',
      'Tommy Hilfiger',
      'Calvin Klein',
      'Zadig + Voltaire',
      'Davidoff',
      'Guess',
      'Yardley',
      'Chloé',
      'Ariana Grande',
      'Kate Spade',
      'Nautica',
      'Kylie',
      'Terenzi',
      'Charlotte Rhys',
    ],
  },
  {
    name: 'Thuthuka Simelane',
    color: 'bg-orange-500',
    textColor: 'text-white',
    hex: '#F97316',
    brands: [
      'Lancôme',
      'Tom Ford',
      'Jo Malone London',
      'Giorgio Armani',
      'Versace',
      'Elizabeth Arden',
      'Yves Saint Laurent',
      'Paco Rabanne',
      'Jean Paul Gaultier',
      'Carolina Herrera',
      'Givenchy',
      'Mugler',
      'Prada',
      'Molton Brown',
      'Michael Kors',
      'Azzaro',
      'Valentino',
      'Antonio Banderas',
      "L'Occitane",
      'Cartier',
      'Aramis',
      'Victor & Rolf',
      'Kenzo',
      'Tabac',
      'Cristiano Ronaldo',
      'Kiehls',
      'Loewe',
      'Maison Margiela',
    ],
  },
  {
    name: 'Haley Valentine',
    color: 'bg-teal-700',
    textColor: 'text-white',
    hex: '#0F766E',
    brands: [
      'Estée Lauder',
      'Clarins',
      'Clinique',
      'La Mer',
      'Dermalogica',
      'Skin Functional',
      'The Ordinary',
      'La Prairie',
      'Nuxe',
      'Skoon',
      'Sisley',
      'Eucerin',
      'Gatineau',
      'Dr Hauschka',
      'Sensai',
      'Bioderma',
      'Erborian',
      'Shiseido',
      'Uriage',
      'Motherkind',
      'Amanda Jayne',
      'Skin Creamery',
      'Pixi',
      'Elemis',
      'Origins',
      'Apivita',
      'Laneige',
      'Dose & Co',
      'Prai',
      'Mary & May',
      'Amazi Skin',
      'Sol de Janeiro',
      'Wrinkles Schminkles',
      'Cosrx',
      'Haruharu',
      'Axis Y',
      'Skin 1004',
      'Beauty of Joseon',
      'Barulab',
      'Mixsoon',
      'Geske',
      'Lelive',
      'Sol de Janeiro',
    ],
  },
  {
    name: 'Delysia Marshall',
    color: 'bg-green-500',
    textColor: 'text-white',
    hex: '#22C55E',
    brands: [
      'Bobbi Brown',
      'Essence',
      'Stila',
      'Revlon',
      'Maybelline',
      'MS London',
      "L'Oréal",
      'Morgan Taylor',
      'Essie',
      'Benefit',
      'Beauty Blender',
      'Sphinx',
      'NYX',
      'Nars',
    ],
  },
  {
    name: 'Delysia Marshall (Haircare)',
    color: 'bg-red-500',
    textColor: 'text-white',
    hex: '#EF4444',
    brands: [
      'Sam McKnight',
      'Tangle Teezer',
      'Charlotte Mensah',
      'Steam Bar',
      'Design Me',
    ],
  },
  {
    name: 'Houston Verus',
    color: 'bg-yellow-400',
    textColor: 'text-black',
    hex: '#FACC15',
    brands: ['Woolworths Internal Only'],
  },
]

// Build a fast lookup: brand name (lowercase) → Buyer
const brandToBuyerMap = new Map<string, Buyer>()
buyers.forEach((buyer) => {
  buyer.brands.forEach((brand) => {
    brandToBuyerMap.set(brand.toLowerCase(), buyer)
  })
})

export function getBuyerForBrand(brandName: string): Buyer | undefined {
  return brandToBuyerMap.get(brandName.toLowerCase())
}
